import signedFetch from './util/signedFetch.js';

export default queryString =>
  signedFetch('searchUserForAdmin', `${__API_BASE__}/admin-console/activation-code-batch/search${queryString}`, 'GET');
